module.exports = __webpack_public_path__ + "static/media/ritesh.913068b3.jpg";